import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class PersonaPictureDeleted extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'PersonaPictureDeleted';

    public constructor(public id: string) {
        super(PersonaPictureDeleted.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: PersonaPictureDeleted): void => {
    const deletedPersonaPicture = state.personaPictures.find(x => x.id == action.id);
    const defaultPersonaPicture = state.personaPictures.find(x => x.id == "0");
    state.personaPictures = state.personaPictures.filter(x => x.id != action.id);
    const personas = state.personas.filter(x => x.picture == deletedPersonaPicture.path);
    personas.forEach(x => x.picture = defaultPersonaPicture.path);
};

//@ts-ignore
registerReducer(PersonaPictureDeleted.ACTION_TYPE, reducer);
